import instance from "@/services/axiosConfig";
import appInstance from "./applicationService/appinstance";

const addShips = (payload) => appInstance.post("/ships", payload);
const addformConfig = (payload) => instance.post("/ships/formconfiguration", payload);
const getformConfig = (payload) => instance.get(`/ships/getconfiguration/${payload}`);


const addshipConfig = (payload) =>
  instance.post("/ships/addshipconfiguration", payload);

const updateShip = (payload) => appInstance.put("/ships", payload);
const patchupdateship = (payload) =>
  appInstance.patch("/ships/updateship", payload);

const getvalidationByTablename = (tablename, fieldname = "") =>
  instance.get(
    `/create/getvalidationByTable/${tablename}${fieldname ? `/${fieldname}` : ""
    }`
  );

const configureuser = (payload) => {
  instance.post("/auth/config", payload);
};
const addModuleMapper = (payload) =>
  instance.post("/ships/module-mapping", payload);

const updateModuleMapper = (payload) =>
  instance.put("/ships/update-module-mapping", payload);

const addModalUser = (payload) => appInstance.post("/ships/adduser", payload);

const getUserbyShips = (shipid) => appInstance.get(`/ships/getuser/${shipid}`);

const getEventbasedmodules = () => instance.get(`/ships/getalleventmodule`);

const getDashboardData = () => appInstance.get(`/ships/dashboard`);

const getShips = () => appInstance.get(`/ships`);

const getShipsModule = (id) => instance.get(`/ships/getmodule-mapping/${id}`);

const getShipById = (id) => appInstance.get(`/ships/${id}`);

const getShipIdDetails = () => {
  const imo_number = localStorage.getItem("imo_number") || 0;
  return appInstance.get(`/ownersettings/getshipbyimo_number/${imo_number}`);
};

const getShipPosition = (userType) => {
  const imo_number =
    localStorage.getItem(userType === "USER" ? "ship_id" : "imo_number") || 0;

  return instance.get(`/owner/getShipposition/${imo_number}`);
};

const getShipTankdetails = (imo_number = localStorage.getItem("imo_number")) => {
 
  return instance.get(`/owner/getshiptankinfo/${imo_number}`);
};

const deleteShips = (id) => appInstance.delete(`/ships/${id}`);

const ownershipDetails = () => instance.get("/ships/getOwnerdetails");

const getAllBenchmarks = () => instance.get(`/ships/benchmark`);

const insertbenchmark = (payload) =>
  instance.post(`/ships/insertbenchmark`, payload);

const commonbenchupdates = (payload) =>
  instance.post(`/ships/commonbenchmark`, payload);

const fetchbenchmarkunits = (reportType) =>
  instance.get(`/ships/fetchbenchmarkunits/${reportType}`);

const getBenchmarks = (id) => instance.get(`/ships/benchmark/${id}`);

const getownershipBenchmarks = (id) =>
  instance.get(`/ships/ownershipbenchmarks/${id}`);

const getProcessData = () => instance.get(`/ships/getprocessdata`);
const getProcessDataByname = (tablename, data) =>
  instance.post(`/ships/getprocessbyname/${tablename}`, data);

const getPgProcessDataByname = (tablename, data) =>
  instance.post(`/ships/getpgprocessbyname/${tablename}`, data);

const getBenchmarkByTablename = (tablename, config = {}) => {
  return instance.get(`/ships/getbenchmarkdata/${tablename}`, config);
};

const getIMOBenchmarkByTablename = (tablename, imo_number) => {
  return instance.get(`/ships/getimobenchmarkdata/${tablename}/${imo_number}`);
};

const getCommonBenchmarkByTablename = (tablename) =>
  instance.get(`/ships/getcommonbenchmarkdata/${tablename}`);

const saveTemporaryData = (payload) =>
  instance.post(`/create/add-temp-data/`, payload);

const syncTempData = (payload) =>
  instance.post(`/create/sync-temp-data/`, payload);

const deleteBenchmarks = (benchid) =>
  instance.delete(`/ships/benchmark/${benchid}`);

const getshipBenchmark = () => instance.get(`/ships/shipbenchmark`);
const getVoyagelist = (ships) => instance.get(`/ships/getVoyages/${ships}`);
const updateShipimage = (imgpayload) =>
  instance.post("/ships/upload", imgpayload);

const editshipBenchmarkAccess = (payload) =>
  instance.post("/ships/shipaccessbenchmark", payload);
const getLastVoyageinfo = () => instance.get("/ships/voyageinfo");
const getshipfilPercentages = (ship_id) =>
  instance.get(`/admin/getshipfillpercentage/${ship_id}`);
const getshipdashboardinfo = (ship_id, date) =>
  instance.get(`/admin/getshipdashboard/${ship_id}${date ? `/${date}` : ""}`);

const getshipemaildashboardinfo = (ship_id) =>
  instance.get(`/admin/getshipemaildashboard/${ship_id}`);


const getshiptimestamp = (ship_id) =>
  instance.get(`/admin/getshiptimestamp/${ship_id}`);

const getownerdashboardinfo = () =>
  instance.get("/admin/getownerdashboardinfo");

const applyupdates = (payload) =>
  instance.post("/mail/send-updates", payload);

const getallVersions = () =>
  instance.get("/mail/get-all-updates");


const shipService = {
  editshipBenchmarkAccess,getallVersions,
  getEventbasedmodules,
  updateShip,
  ownershipDetails,
  getvalidationByTablename,
  addShips,
  addformConfig,
  getformConfig,
  deleteShips,
  updateModuleMapper,
  getDashboardData,
  getShips,
  addModuleMapper,
  getShipsModule,
  getShipById,
  getUserbyShips,
  addModalUser,
  getShipIdDetails,
  patchupdateship,
  getAllBenchmarks,
  getBenchmarks,
  getProcessData,
  getProcessDataByname,
  getPgProcessDataByname,
  insertbenchmark,
  getBenchmarkByTablename, getIMOBenchmarkByTablename,
  saveTemporaryData,
  syncTempData,
  deleteBenchmarks,
  getshipBenchmark,
  getVoyagelist,
  commonbenchupdates,
  getCommonBenchmarkByTablename,
  updateShipimage,
  getShipTankdetails,
  getShipPosition,
  addshipConfig,
  fetchbenchmarkunits,
  configureuser,
  getownershipBenchmarks,
  getLastVoyageinfo, getshipdashboardinfo, getshipemaildashboardinfo,
  getshipfilPercentages, getownerdashboardinfo, getshiptimestamp, applyupdates
};
export default shipService;
